"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const client_1 = require("@apollo/client");
//
// assets
//
const blankBackground_webp_1 = __importDefault(require("assets/images/blankBackground.webp"));
const HeroImage_1 = __importDefault(require("components/onboarding/HeroImage"));
const cache_1 = require("cache");
const queryDefinitions_1 = require("queryDefinitions");
const loginCopy_1 = require("copy/loginCopy");
const tokenHeader_1 = require("tokenHeader");
//
// components
//
const OnboardingForm_1 = __importDefault(require("components/onboarding/OnboardingForm"));
const GenericInput_1 = __importDefault(require("components/general/inputs/GenericInput"));
const PasswordInput_1 = __importDefault(require("components/general/inputs/PasswordInput"));
const FormValidation_1 = require("components/general/utility/FormValidation");
//
// styles
//
const StyledImageBackground_1 = require("components/onboarding/styles/StyledImageBackground");
const LocalAccount_1 = __importDefault(require("LocalAccount"));
const AccountContext_1 = require("contexts/AccountContext");
const LogIn = () => {
    var _a, _b;
    const { setAccount } = (0, AccountContext_1.useAccount)();
    const [email, setEmail] = (0, react_1.useState)('');
    const [password, setPassword] = (0, react_1.useState)('');
    const [emailError, setEmailError] = (0, react_1.useState)('');
    const [passwordError, setPasswordError] = (0, react_1.useState)('');
    const linkProps = {
        preface: loginCopy_1.loginCopy.linkPreface,
        href: loginCopy_1.loginCopy.linkHref,
        prompt: loginCopy_1.loginCopy.linkPrompt
    };
    const resetProps = {
        href: loginCopy_1.loginCopy.forgotPasswordHref,
        prompt: loginCopy_1.loginCopy.forgotPassword
    };
    const navigate = (0, react_router_dom_1.useNavigate)();
    const location = (0, react_router_dom_1.useLocation)();
    const from = ((_b = (_a = location.state) === null || _a === void 0 ? void 0 : _a.from) === null || _b === void 0 ? void 0 : _b.pathname) || '/orders';
    function handleBlur(event) {
        const error = (0, FormValidation_1.validateInput)(event.target.id, event.target.value);
        if (error) {
            if (event.target.id === 'email') {
                setEmailError(error);
            }
            if (event.target.id === 'password') {
                setPasswordError(error);
            }
        }
        else {
            if (event.target.id === 'email') {
                setEmailError('');
            }
            if (event.target.id === 'password') {
                setPasswordError('');
            }
        }
    }
    function handleInputChange(event) {
        if (event.target.id === 'email') {
            setEmail(event.target.value);
        }
        if (event.target.id === 'password') {
            setPassword(event.target.value);
        }
    }
    const [login, { data: loginData, loading: loginLoading, error: loginError }] = (0, client_1.useMutation)(queryDefinitions_1.LOGIN_USER, {
        onCompleted({ signIn }) {
            if (signIn) {
                localStorage.setItem('token', signIn.session.token);
            }
        }
    });
    const [authedLazyQuery, 
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'data' does not exist on type '((options?... Remove this comment to see the full error message
    { data: accountData, loading: accountLoading, error: accountError }] = (0, tokenHeader_1.useAuthedLazyQuery)(queryDefinitions_1.GET_ACCOUNTS);
    function handleLogin(e) {
        e.preventDefault();
        login({ variables: { input: { email: email, password: password } } });
    }
    // .FIXME: this needs to be refactored.. we shouldn't use objects in useEffect
    // dependencies because react doesn't do deep equality and there are better
    // ways to chain apollo client queries
    (0, react_1.useEffect)(() => {
        if (loginData && !accountData) {
            // @ts-expect-error ts-migrate(2349) FIXME: This expression is not callable.
            authedLazyQuery({ variables: { first: 1 } });
        }
        if (accountData) {
            setAccount(accountData.accounts.edges[0].node);
            // LocalAccount should no longer be necessary when we start using the
            // account context, but for now there's some duplication
            LocalAccount_1.default.set(accountData.accounts.edges[0].node);
            (0, cache_1.isLoggedInVar)(true);
            navigate(from, { replace: true });
        }
    }, [loginData, accountData, from]);
    let apiError = loginError;
    if (accountError) {
        apiError = accountError;
    }
    if (apiError) {
        apiError.title = loginCopy_1.loginCopy.errorTitle;
    }
    let apiLoading = false;
    if (loginLoading || accountLoading) {
        apiLoading = true;
    }
    return (react_1.default.createElement(StyledImageBackground_1.StyledImageBackground, { id: 'login', url: blankBackground_webp_1.default },
        react_1.default.createElement(OnboardingForm_1.default, { apiError: apiError, contactLink: linkProps, cta: loginCopy_1.loginCopy.cta, header: loginCopy_1.loginCopy.header, inputs: [
                react_1.default.createElement(GenericInput_1.default, { error: emailError, id: 'email', key: 'email', label: loginCopy_1.loginCopy.input1, onBlur: handleBlur, onInputChange: handleInputChange }),
                react_1.default.createElement(PasswordInput_1.default, { error: passwordError, id: 'password', key: 'password', label: loginCopy_1.loginCopy.input2, onBlur: handleBlur, onInputChange: handleInputChange })
            ], loading: apiLoading, onFormSubmit: handleLogin, resetPrompt: resetProps }),
        react_1.default.createElement(HeroImage_1.default, { header: loginCopy_1.loginCopy.heroHeader, subheader: loginCopy_1.loginCopy.heroSubHeader })));
};
exports.default = LogIn;
